import { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { EffectCoverflow } from "swiper";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import slide_image_1 from "../../../assets/images/slider/sliderImages/sliderImage1.png";
import slide_image_2 from "../../../assets/images/slider/sliderImages/sliderImage2.png";
import slide_image_3 from "../../../assets/images/slider/sliderImages/sliderImage3.png";
// import slide_image_4 from "../../../assets/images/slider/sliderImages/sliderImage4.png";
import slide_image_5 from "../../../assets/images/slider/sliderImages/sliderImage5.png";
// import slide_image_6 from "../../../assets/images/slider/sliderImages/sliderImage6.png";
// import slide_image_7 from "../../../assets/images/slider/sliderImages/sliderImage7.png";
import slide_image_8 from "../../../assets/images/slider/sliderImages/sliderImage8.png";

function Slider() {
    const swiperRef: any = useRef(null);
    const autoSlideTimer = useRef<NodeJS.Timeout | null>(null);
    const inactivityTimer = useRef<NodeJS.Timeout | null>(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [slidesPerView, setSlidesPerView] = useState(2);
    const slides = [slide_image_1, slide_image_2, slide_image_3, slide_image_5, slide_image_8];

    useEffect(() => {
        const handleResize = () => {
            setSlidesPerView(window.innerWidth < 768 ? 1 : 2);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handlePrev = () => {
        swiperRef.current?.slidePrev();
        resetAutoSlideTimer();
    };

    const handleNext = () => {
        swiperRef.current?.slideNext();
        resetAutoSlideTimer();
    };

    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideTimer.current = setInterval(() => {
            swiperRef.current?.slideNext();
        }, 3000);
    };

    const stopAutoSlide = () => {
        if (autoSlideTimer.current) {
            clearInterval(autoSlideTimer.current);
            autoSlideTimer.current = null;
        }
    };

    const resetAutoSlideTimer = () => {
        stopAutoSlide();
        if (inactivityTimer.current) {
            clearTimeout(inactivityTimer.current);
        }
        inactivityTimer.current = setTimeout(() => {
            startAutoSlide();
        }, 5000);
    };

    useEffect(() => {
        startAutoSlide();
        return () => {
            stopAutoSlide();
            if (inactivityTimer.current) {
                clearTimeout(inactivityTimer.current);
            }
        };
        // eslint-disable-next-line
    }, []);

    return (
        <div className="swiper-container">
            <Swiper
                effect={"coverflow"}
                grabCursor={true}
                centeredSlides={true}
                loop={true}
                slidesPerView={slidesPerView}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                coverflowEffect={{
                    rotate: 0,
                    stretch: 150,
                    depth: 150,
                    modifier: 2.5,
                }}
                modules={[EffectCoverflow]}
                className="swiper_container"
            >
                {slides.map((image, index) => (
                    <SwiperSlide key={index}  >
                        <LazyLoadImage
                            src={image}
                            alt={`slide ${index}`}
                            effect="blur"
                            width="100%"
                            height="100%"
                            style={{ objectFit: 'cover' }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className="slider-controler">
                <button className="slider-arrow prev" onClick={handlePrev}>
                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.12132 7.49999H19V10.5H6.12132L11.0607 15.4393L8.93934 17.5607L0.378681 8.99999L8.93934 0.439331L11.0607 2.56065L6.12132 7.49999Z" fill="#999999" />
                    </svg>
                </button>

                <div className="custom-pagination">
                    {slides.map((_, index) => (
                        <span key={index} className={`pagination-dot ${index === activeIndex ? "active" : ""}`}></span>
                    ))}
                </div>

                <button className="slider-arrow next" onClick={handleNext}>
                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.12132 7.49999H19V10.5H6.12132L11.0607 15.4393L8.93934 17.5607L0.378681 8.99999L8.93934 0.439331L11.0607 2.56065L6.12132 7.49999Z" fill="#999999" />
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default Slider;